import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  transform(sizeInBytes?: number): string {
    if (!sizeInBytes) {
      return '';
    }
    if (isNaN(sizeInBytes) || sizeInBytes === 0) return '0 Bytes';

    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));

    return `${sizeInBytes / Math.pow(1024, i)} ${units[i]}`;
  }
}
